<form [formGroup]="form" (ngSubmit)="onSubmitForm($event)">
  <div class="form-group pt-2">
    <label class="form-label" for="service">
      {{ 'Settings::VirtualTranslator:Service' | abpLocalization }}
    </label>
    <ca-select formControlName="service" class="below-all">
      <ca-option *ngFor="let serviceType of serviceTypes" [value]="serviceType.code">
        {{ 'GenericLookup::' + serviceType.code | abpLocalization }}
      </ca-option>
    </ca-select>
    <small class="form-text text-muted">
      {{ 'Settings::VirtualTranslator:Service:Description' | abpLocalization }}
    </small>
  </div>
  <button type="button" type="submit" class="btn btn-primary mt-3" [disabled]="!form.valid">
    <i class="me-1 fas fa-save"></i>
    {{ 'AbpUi::Save' | abpLocalization }}
  </button>
</form>
